import React from 'react';
import './view.less';

/**
 * @class CnSmartDetail
 * @description 
 */
export default class CnSmartDetail extends React.Component {
  static displayName = 'CnSmartDetail';

  constructor(props) {
    super(props);
  }

  render() {
    return this.props.children;
  }
}
